<section>
    <div>
        <span>{{ label | titlecase }}</span>
        <span>{{ data }}</span>
    </div>
    <ng-content></ng-content>
</section>
